import { createFileRoute } from '@tanstack/react-router'

import { routeOptions, SignUpPage } from '@/modules/auth'

export const Route = createFileRoute('/sign-up')({
  ...routeOptions,
  staticData: { title: 'Sign up' },
  component: SignUpPage,
})
